import SettingsIcon from '@mui/icons-material/Settings';
import { Tooltip } from '@mui/material';
import React from 'react';

export default function IconConfig({...props}) {
  return <Tooltip title='Configurações'><SettingsIcon  {...props} /></Tooltip>;
}